const JIANDE_COUNTY_ID = 21310
const XIHU_COUNTY_ID = 20393

export const ALL_CUNLUO = [
  { name: '李村村', cunName: '李村村', adcdid: '41306', countyid: JIANDE_COUNTY_ID },
  { name: '上吴方村', cunName: '上吴方村', adcdid: '15687', countyid: JIANDE_COUNTY_ID },
  { name: '新叶村', cunName: '新叶村', adcdid: '1057', countyid: JIANDE_COUNTY_ID },
  { name: '三墩五里塘', cunName: '三墩五里塘', adcdid: null, countyid: XIHU_COUNTY_ID },
  { name: '留下老街', cunName: '留下老街', adcdid: null, countyid: XIHU_COUNTY_ID },
  { name: '杭大新村', cunName: '杭大新村', adcdid: null, countyid: XIHU_COUNTY_ID }
]

function normalizeId(id) {
  if (id === null || id === undefined || id === '') return null
  const num = Number(id)
  return Number.isNaN(num) ? id : num
}

export function getUserCountyId(userInfo = {}) {
  const countyId =
    userInfo.countyid ??
    userInfo.adcdid ??
    userInfo.attributes?.countyid ??
    userInfo.attributes?.adcdid

  return normalizeId(countyId)
}

export function getAccessibleCunluoList(userInfo = {}) {
  const countyId = getUserCountyId(userInfo)
  if (countyId === null) return []

  return ALL_CUNLUO.filter(item => normalizeId(item.countyid) === countyId)
}

export function getAccessibleCunluoNames(userInfo = {}) {
  return getAccessibleCunluoList(userInfo).map(item => item.name)
}

export function getAccessibleCunluoAdcdList(userInfo = {}) {
  return getAccessibleCunluoList(userInfo)
    .filter(item => item.adcdid)
    .map(item => ({ cunName: item.cunName, adcdid: item.adcdid }))
}

export function getDefaultCunluoName(userInfo = {}) {
  const list = getAccessibleCunluoNames(userInfo)
  return list[0] || ''
}

export function getAccessibleCunluoAdcdIds(userInfo = {}) {
  return getAccessibleCunluoAdcdList(userInfo)
    .map(item => item.adcdid)
    .filter(Boolean)
}
